import React from "react";

import { Tabs } from "@material-ui/core";

export default ({ children, ...rest }) => {
	return <Tabs {...rest}>{children}</Tabs>;
};
